import React from 'react';
import { useSelector } from 'react-redux';
import { SearchAppState, SearchState } from '../search-model';
import { filterList } from '../search-helper';
import { usePagination } from '../../pages/arc/shared-slices/usePagination';

interface SearchListProps {
	renderList: (item: any) => JSX.Element;
	renderPagination?: (listCount: number, listName: string) => JSX.Element;
	emptyMessage?: string;
	showAll?: boolean;
}
interface PageRange {
	begin: number;
	end: number
}

const getListByPage = (currentPage: number, totalCounts: number): PageRange => {
	return currentPage * 10 < totalCounts
		? { begin: (currentPage - 1) * 10, end: currentPage * 10 }
		: { begin: (currentPage - 1) * 10, end: totalCounts };
};

export const SearchList = (props: React.PropsWithChildren<SearchListProps>) => {

	const state = useSelector<SearchAppState, SearchState>(a => a.searchState);
	const name = `${state.appName}-${JSON.stringify(state.filters)}`;
	const filteredList = filterList(state.filters, state.lists, state.sortBy);
	const pagination = usePagination(name, Math.ceil(filteredList?.length / 10), 1);
	if (!filteredList || filteredList.length === 0) {
		return <div>{props.emptyMessage}</div>;
	}

	if (!pagination) {
		return null;
	}

	const range = getListByPage(pagination?.currentPage, filteredList?.length);


	return (
		<>
			{
				filteredList?.length > 10 && !props?.showAll ? filteredList?.slice(range.begin, range.end).map(a => props.renderList(a)) : filteredList?.map(a => props.renderList(a))
			}
			{
				!!props.renderPagination && props.renderPagination(filteredList?.length, name)
			}
		</>
	);

};

SearchList.defaultProps = {
	emptyMessage: '',
	renderPagination: null,
	showAll: false,
};